import UserPreferences from '@/creditflowresearch/ui/common/components/organisms/UserPreferences';
import UserProfileMenuTemplate from './UserProfileMenuTemplate';

interface IUserProfileMenuTemplateMobileProps {
  onClose?: () => void,
}

const UserProfileMenuTemplateMobile = ({ onClose }: IUserProfileMenuTemplateMobileProps) => {
  return (
    <UserProfileMenuTemplate onClose={ onClose }>
      <UserPreferences isMobile />
    </UserProfileMenuTemplate>
  );
};

export default UserProfileMenuTemplateMobile;
